<template>
  <div>
    <select
      v-model="selectedOrder"
      @change="navigateToOrder()"
      class="form-select w-full text-gray-400"
    >
      <option value="0" selected>History</option>
      <option
        v-for="(order, index) in history"
        :key="index"
        :value="order.orderNumber"
      >
        {{ order.customerName }} #{{ order.orderNumber }}
      </option>
    </select>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "OrderNavigationHistory",
  data() {
    return {
      selectedOrder: 0,
    }
  },
  computed: {
    history() {
      return this.$store.getters['orders/getNavigationHistory'];
    },
  },
  methods: {
    navigateToOrder() {
      if (! Number(this.selectedOrder)) {
        return false;
      }

      if (this.tryingToNavigateToSameRoute()) {
        this.selectedOrder = 0;
        return false;
      }

      router.push({ name: 'Orders', params: { orderNumber: this.selectedOrder }});
      this.selectedOrder = 0;
    },
    tryingToNavigateToSameRoute() {
      return (this.$route.name == 'Orders')
        && (this.$route.params.orderNumber == this.selectedOrder);
    }
  }
};
</script>
